import { CustomerEnum } from "../types/context-detection";
import { LazyLoadedZeroQueryContext, ISearchBoxProps } from "../types/searchbox";
import { initPersonalization } from "./personalization/store";

export function lazyLoadZeroQueryContext(customerType: CustomerEnum): void {
    const parsedContext = parseZeroQueryRequestContext();

    if (parsedContext) {
        const isPrivateCustomer = customerType === CustomerEnum.Private;
        initPersonalization(parsedContext, isPrivateCustomer);
    }
}

function parseZeroQueryRequestContext(): LazyLoadedZeroQueryContext | undefined {
    for (const key of SEARCH_BOX_STATES_FOR_ZERO_QUERY) {
        const ctx = window[key] as ISearchBoxProps | undefined;

        if (ctx != null) {
            const zeroQueryContext: LazyLoadedZeroQueryContext = {
                isFeatureEnabled: ctx.isZeroQueryEnabled,
                suggestionApiUrl: ctx.apiUrl,
                recoApiUrl: ctx.recoApiUrl
            };
            return zeroQueryContext;
        }
    }
    console.debug(
        "[SSW Zero Query] Exhausted all state keys. No zero query request context found."
    );
    return undefined;
}

const SEARCH_BOX_STATES_FOR_ZERO_QUERY: Array<keyof Window> = [
    "__PRELOADED_SEARCHBOX_WIDE_STATE__",
    "__PRELOADED_SEARCHBOX_FLYOUT_STATE__",
    "__PRELOADED_SEARCHBOX_GRID_STATE__",
    "__PRELOADED_SEARCHBOX_MEGAMENU_STATE__"
];
